import { AnimatePresence, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import '../../styles/CssReset.css'
import DataListLoaders from './components/DataListLoader'
import './styles.css'

export default function ContestantList() {
    const { t } = useTranslation('ContestantList')

    return (
        <AnimatePresence mode="wait">
            <motion.main
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 50 }}
                transition={{ duration: 0.3 }}
                className="pt-3"
            >
                {/* <div className="mb-7 h-[3px] w-32 rounded-full bg-white" /> */}
                <div className="mb-9 flex items-center justify-between">
                    <h2 className="text-3xl font-extrabold capitalize leading-[0]">{t('Contestant List')}</h2>
                </div>
                <DataListLoaders />
            </motion.main>
        </AnimatePresence>
    )
}
